import { Dialog, useTheme, alpha } from '@mui/material';

const FormulaItemDialog: typeof Dialog = (props) => {
  const theme = useTheme();

  return (
    <Dialog
      {...props}
      PaperProps={{
        sx: {
          width: theme.spacing(48),
          padding: theme.spacing(2),
          borderRadius: theme.spacing(1),
          background: theme.palette.grey[900],
        },
      }}
      slotProps={{
        backdrop: {
          sx: { background: alpha(theme.palette.common.white, 0.25) },
        },
      }}
      keepMounted
    />
  );
};

export default FormulaItemDialog;
